export enum AssetTypes {
    Brochure = 'brochure',
    LookBook = 'lookbook',
    Adv = 'adv',
    Document = 'document',
    StillLife = 'stilllife',
    Video = 'video'
};